module.exports = __webpack_public_path__ + "static/media/resume-2020.96a955bb.pdf";